import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {Domain} from '@twpub/core/models/domain';
import {DisplayDomain} from '@twpub/core/models';
import {NgClass} from '@angular/common';

@Component({
  selector: 'pub-domain-item',
  templateUrl: './domain-item.component.html',
  styleUrls: ['./domain-item.component.scss'],
  standalone: true,
  imports: [NgClass]
})
export class DomainItemComponent implements OnChanges {
  @Input() selectedIds: (number | undefined)[] = [];
  @Input() domain!: Domain | DisplayDomain;
  @Input() showCheckbox: boolean = false;
  @Output() selected = new EventEmitter<number[]>();

  isSelected: boolean = false;

  ngOnChanges(): void {
    this.isSelected = this.selectedIds.some(id => id === this.domain.id)
  }

  onSelect() {
    this.selected.emit([this.domain.id]);
  }
}
